/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React, { Component } from 'react';
import { getSDGShortTitle } from '../../constants/sdg-data';
import { SimpleTooltip } from '../simple-tooltip';
import './styles.scss';
import NumberFormat from '../../utils/number-format';
import { SDG_CODES } from '../../constants/utr';
class ScorecardStatusbar extends Component {

  state = {
    uniqueId: ''
  };

  componentDidMount() {
    this.setState({ uniqueId: Math.random().toString(36).substr(2, 9) });
  }

  getTooltip = (sdgCode, score) => {
    const { tooltipPrefix } = this.props;
    return <div>
      {tooltipPrefix}
      <div>SDG {sdgCode}: {getSDGShortTitle(sdgCode)}: <NumberFormat value={score} suffix={'%'}/></div>
    </div>
  }

  render() {
    const { goals } = this.props;
    const { uniqueId } = this.state;
    const { handleClick } = this.props;

    if (!goals) {
      return '';
    }

    return <div className='scorecard-statusbar'>
      {SDG_CODES.map(sdgCode => {
        const enabled = goals[sdgCode] && goals[sdgCode] > 0;
        const className = enabled ? 'sdg-bg-' + sdgCode + '-5' : 'background-ThemeNeutralsLight';
        const id = `sdgstatusbar-${uniqueId}-${sdgCode}`;
        const tooltip = this.getTooltip(sdgCode, goals[sdgCode]);
        return (
          <SimpleTooltip key={id} text={tooltip}>
            <div onClick={handleClick ? () => handleClick(sdgCode) : undefined} className={`sdg-block ${className} ${handleClick ? 'clickable' : ''}`} />
          </SimpleTooltip>
        );
      })}
    </div>
  }
}

export default ScorecardStatusbar;
